module.exports = __webpack_public_path__ + "static/media/shaolaishan_package.7ae147b7.webp";